/* global axios */
import ApiClient from './ApiClient';

class InboxHolidaysAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  list(inboxId) {
    return axios.get(`${this.url}/${inboxId}/inbox_holidays`);
  }

  create(inboxId, holiday) {
    return axios.post(`${this.url}/${inboxId}/inbox_holidays`, {
      inbox_holiday: holiday,
    });
  }

  update(inboxId, holidayId, holiday) {
    return axios.patch(`${this.url}/${inboxId}/inbox_holidays/${holidayId}`, {
      inbox_holiday: holiday,
    });
  }

  delete(inboxId, holidayId) {
    return axios.delete(`${this.url}/${inboxId}/inbox_holidays/${holidayId}`);
  }
}

export default new InboxHolidaysAPI();
